import { FormControl, MenuItem, Select } from "@mui/material";
import React from "react";

function ActiveFilterComponent({ onChange, value, filters }) {
  return (
    <FormControl
      className="w-full sm:w-[126px]"
      sx={{
        height: "32px",
        fontSize: "12px",
        "& .MuiOutlinedInput-root": {
          "& fieldset": {
            // borderColor: "#E1E6EC",
            // borderWidth: "1px",
            border: "none",
          },
          "&:hover fieldset": {
            // borderColor: "#E1E6EC",
            // borderWidth: "1px",
            border: "none",
          },
          "&.Mui-focused fieldset": {
            // borderColor: "#3F6F8F",
            // borderWidth: "1px",

            border: "none",
          },
        },
      }}
    >
      <Select
        value={value}
        onChange={onChange}
        displayEmpty
        MenuProps={{
          PaperProps: {
            sx: {
              mt: 1,
            },
          },
        }}
        sx={{
          backgroundColor: "white",
          fontSize: "12px",
          padding: "5px 0px",
          height: "32px",
          color: "#1D4469",
          "& .MuiSelect-icon": {
            color: "#1D4469",
          },
          "&.Mui-focused": {
            backgroundColor: "#CECECE4D",
            color: "#313F51",
          },

          "&:hover": {
            backgroundColor: "#CECECE4D",
            color: "#313F51",
          },
        }}
      >
        {filters.map((option) => (
          <MenuItem
            key={option.value}
            value={option.value}
            sx={{
              fontSize: "12px",
              "&:hover": {
                backgroundColor: "#E1E6EC",
              },
              "&.Mui-selected": {
                backgroundColor: "white",
              },
              "&.Mui-selected:hover": {
                backgroundColor: "#E1E6EC",
              },
            }}
          >
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

export default ActiveFilterComponent;
